import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mot-de-passe-oublie",
  "data-model-id": "3:5033"
}
const _hoisted_2 = { class: "reset-container" }
const _hoisted_3 = { class: "reset-content" }
const _hoisted_4 = { class: "logo-section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  alt: "Florisuite Logo",
  src: "https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
}, null, -1)
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "form-title" }, "Mot de passe oublié ?"),
  /*#__PURE__*/_createElementVNode("p", { class: "form-subtitle" }, " Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\"><label class=\"form-label\" for=\"email\">Email</label><input class=\"form-input\" type=\"email\" id=\"email\" placeholder=\"votre.email@exemple.com\" required></div><button class=\"submit-button\" type=\"submit\"><span class=\"button-text\">Envoyer le lien de réinitialisation</span></button>", 2)
const _hoisted_10 = [
  _hoisted_8
]
const _hoisted_11 = { class: "back-to-login" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-icon",
  alt: "Arrow",
  src: "https://c.animaapp.com/nNxA75tB/img/arrow-left.svg"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Retour à la connexion", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"info-section\"><div class=\"info-card\"><img class=\"info-icon\" alt=\"Info\" src=\"https://c.animaapp.com/nNxA75tB/img/info.svg\"><div class=\"info-content\"><h3 class=\"info-title\">Besoin d&#39;aide ?</h3><p class=\"info-text\"> Si vous ne recevez pas l&#39;email dans les 5 minutes, vérifiez votre dossier spam ou <a href=\"/contact\" class=\"contact-link\">contactez notre support</a>. </p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RouterLink, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            class: "reset-form",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)), ["prevent"]))
          }, _hoisted_10, 32),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: "/connexion",
              class: "back-link"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_14
      ])
    ])
  ]))
}